import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SavedSearchService } from '../../../services/saved-search.service';
import { RenameQueryDialogData } from '../../../interfaces/saved-search.interface';

@Component({
  selector: 'app-rename-query-dialog',
  templateUrl: './rename-query-dialog.component.html',
  styleUrls: ['./rename-query-dialog.component.less']
})
export class RenameQueryDialogComponent implements OnInit {
  renameForm: UntypedFormGroup;
  loading = false;
  dialogData: RenameQueryDialogData;

  constructor(
    private fb: UntypedFormBuilder,
    private modalRef: NzModalRef,
    private savedSearchService: SavedSearchService,
    private message: NzMessageService
  ) {
    this.dialogData = this.modalRef.getConfig().nzData || {};
    this.renameForm = this.fb.group({
      queryName: [this.dialogData.currentName || '', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]]
    });
  }

  ngOnInit(): void {}

  get f() {
    return this.renameForm.controls;
  }

  onSave(): void {
    if (this.renameForm.invalid) {
      Object.values(this.renameForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return;
    }

    const newName = this.renameForm.value.queryName.trim();

    if (newName === this.dialogData.currentName) {
      this.message.info('No changes to save');
      this.modalRef.close(false);
      return;
    }

    this.loading = true;

    this.savedSearchService.renameSavedSearch(
      this.dialogData.queryId,
      newName,
      this.dialogData.dashboardId
    ).subscribe({
      next: () => {
        this.loading = false;
        this.message.success('Query renamed successfully');
        this.modalRef.close(true);
      },
      error: (error) => {
        this.loading = false;
        if (error.error?.message?.includes('duplicate') || error.error?.message?.includes('already exists')) {
          this.message.error('A query with this name already exists. Please choose a different name.');
        } else {
          this.message.error(error.error?.message || 'Failed to rename query. Please try again.');
        }
      }
    });
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
